import { prop, compose, indexBy, pluck, path, assoc, uniq, append, reject, equals, dissoc, pathOr, pipe, assocPath, not, lensPath, set, filter, any, contains, sortWith, descend, ascend, sort, comparator, uniqBy, propOr, head, toPairs, map, find, propEq, reduce, reduced, whereEq, flatten } from 'ramda';
import { bind } from 'redux-effects';
import { v4 } from 'uuid';
import { fetchLottoBundles, fetchLottoPrices, searchGames } from '@rushplay/api-client';
import { combineReducers, bindActionCreators } from 'redux';
import querystring from 'querystring';
import { FETCH } from 'redux-effects-fetch';
import React from 'react';
import PropTypes$1, { PropTypes } from 'prop-types';
import { setPropTypes } from 'recompose';
import { connect } from 'react-redux';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var BUNDLES_UPDATED = 'casino/lottery/BUNDLES_UPDATED';
var EFFECT_FETCH = 'casino/lottery/EFFECT_FETCH';
var FETCH_RESULT = 'casino/lottery/FETCH_RESULT';
var QUERY_CLEARED = 'casino/lottery/QUERY_CLEARED';
var QUERY_UPDATED = 'casino/lottery/QUERY_UPDATED';
var TICKETS_UPDATED = 'casino/lottery/TICKETS_UPDATED';
var START_TRACKING_REQUEST = 'START_TRACKING_REQUEST';
var STOP_TRACKING_REQUEST = 'STOP_TRACKING_REQUEST';

/**
 * Request configuration object
 *
 * Used to create action for `redux-effects-fetch`. `success` and `failure`
 * action creators are called with response object:
 *   - `url` - The URL of the endpoint you requested (as returned by the request)
 *   - `status` - The numerical status code of the response (e.g. `200`)
 *   - `statusText` - The text version of the status (e.g. `OK`)
 *   - `headers` - A [Headers object](https://developer.mozilla.org/en-US/docs/Web/API/Headers)
 *   - `value` - The deserialized value of the response. This may be an object or string, depending on the type of response (json or text)
 *
 * @typedef {Object} FetchConfig
 * @prop {Function} [success] - Success action creator
 * @prop {Function} [failure] - Failure action creator
 * @prop {string} [token] - Security token
 * @prop {bool} [normalize] - Specifies if response should be normalized. See https://github.com/paularmstrong/normalizr for more details
 * @prop {number} [version] - API endpoint version
 * @prop {number} [cacheFor] - Specifies for how many ms response should be cached. Can be Infinity
 * @prop {Object} [params] - Request params that goes to actual fetch
 * @prop {number} [params.timeout] -  Request timeout in ms, request promise will be rejected
 * if request does not complete in specified amount of time
 */
/* istanbul ignore next */

function noop() {}

var defaultParams = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
  /**
   * Add authorization token as header (if present) to `fetch` params
   *
   * @private
   * @param {Object} params - `fetch` params
   * @returns `fetch` params with `Authorization` header
   */

};

function withAuthorizationHeader(token) {
  if (!token) {
    return defaultParams;
  }

  var authorizationHeaderLens = lensPath(['headers', 'Authorization']);
  return set(authorizationHeaderLens, token, defaultParams);
}
/**
 * Add API version as header (if present) to `fetch` params
 *
 * @private
 * @param {Object} params - `fetch` params
 * @returns `fetch` params with `Accept` header
 */


function withVersionHeader(version, params) {
  if (!version) {
    return params;
  }

  var versionHeaderLens = lensPath(['headers', 'Accept']);
  return set(versionHeaderLens, "application/vnd.casinosaga.v".concat(version), params);
}

var cache = {};

function request(url, config) {
  var success = config.success || noop;
  var failure = config.failure || noop;
  var params = Object.assign({}, withVersionHeader(config.version, withAuthorizationHeader(config.token)), config.params);

  if (cache[url] && config.params.method === 'GET' && Date.now() < cache[url].expiresAt) {
    return success(cache[url].value);
  }

  if (params.body) {
    params.body = JSON.stringify(params.body);
  }

  var uuid = v4();
  return bind({
    type: EFFECT_FETCH,
    payload: {
      url: url,
      params: params
    },
    meta: {
      uuid: uuid
    }
  }, function (res) {
    /* istanbul ignore else */
    if (config.cacheFor) {
      cache[url] = {
        expiresAt: Date.now() + config.cacheFor,
        value: res
      };
    }

    return success(res);
  },
  /* istanbul ignore next */
  function (res) {
    return failure(res);
  });
}
/**
 * Function for constructing HTTP GET action which is used in redux-effects-fetch
 *
 * @private
 * @param {String} request url
 * @param {FetchConfig} config
 * @returns {Object} action object which is used for HTTP GET request
 */


function getRequest(url, config) {
  var params = getParams(config, 'GET');
  return request(url, params);
}
/**
 * Get request params
 *
 * @private
 * @param {FetchConfig} config
 * @param {string} method
 */


function getParams(config, method) {
  var paramsMethodLens = lensPath(['params', 'method']);
  var params = set(paramsMethodLens, method, config);
  return params;
}

/**
 * JackpotItem
 * @typedef {Object} JackpotItem
 * @prop {number} baseJackpot - Jackpot in Euro (Needed to calculate draw price)
 * @prop {number} baseMarketingJackpot - Marketing jackpot in Euro (Needed to calculate draw price)
 * @prop {number} jackpot - Jackpot
 * @prop {number} marketingJackpot - Marketing jackpot
 * @prop {string} subgame - Jackpot type ("" is default)
 */

/**
 * DrawItem
 * @typedef {Object} DrawItem
 * @prop {Array.<JackpotItem>} jackpots - List of jackpots
 * @prop {string} closingDate - Date when the draw closes (ex: "2019-04-15T06:27:30+00:00")
 * @prop {string} drawingDate - Date when the draw is made (ex: "2019-04-15T06:27:30+00:00")
 * @prop {string} drawingType - Draw type (ex: "SU", "WE", "NORMAL")
 * @prop {string} id - The draws unique identifier (ex: "bfa8fae9-be72-42db-946c-71d6c404368a")
 * @prop {string} productId - The lottery product id of the draw (ex: "keno247")
 * @prop {string} state - The state of the draw (ex: "open", "finished")
 */

/**
 * LotteryItem
 * @typedef {Object} LotteryItem
 * @prop {Array.<DrawItem>} draws - Draw objects for the lottery
 * @prop {bool} openInIframe - Indicates if the lottery should be opened in an iframe
 * @prop {number} imageUrl - The image URL for the lottery
 * @prop {number} jackpot - The lottery's current jackpot
 * @prop {number} maxLines - Max number of lines that's available for the lottery
 * @prop {number} price - The lottery's current price
 * @prop {string} productId - The lottery's unique identifier
 */

/**
 * PriceItem - Draw price
 * @typedef {Object} PriceItem
 * @prop {string} currency - Currency (ex: "SEK")
 * @prop {string} id - Unique identifier (ex: "f52fc39b-cba3-495e-ad99-32a9975eed9b")
 * @prop {number} jackpotUpperLimit - Jackpot upper limit in Euro ()
 * @prop {Array.<Object>} prices (ex: [{option: "", perLine: true, perDraw: true, price: 2700, price_dbjp: 2700}])
 * @prop {string} productId - The lottery product id of the draw (ex: "keno247")
 */

/**
 * LotteryItemConfig - Config for a lottery item
 * @typedef {Object} LotteryItemConfig
 * @prop {number} id - Game id of the lottery
 * @prop {array} tags - Tags which the lottery has been tagged with (to be used to do categories etc)
 * @prop {string} imageUrl - Image of the lottery
 * @prop {number} jackpotValue - Jackpot value to display (in case the API doesn't contain this data, which is true for instant lotteries)
 * @prop {number} maxLinesCount - Max lines to bet on the given lottery
 */

/**
 * @private
 * @param {Array.<LotteryItem>} lotteryItems Array of product objects
 * @param {array} tags Array of tag strings
 * @returns {Array.<LotteryItem>} Returns array of lottery items which matches any of the tags
 */

function getLotteryItemsByCategories(lotteryItems, tags) {
  return filter(function (lottery) {
    return any(function (tag) {
      return contains(tag, tags);
    }, lottery.tags);
  }, lotteryItems);
}
/**
 * Sort lottery items according to:
 * - Jackpot present & not openInIframe: Keep order but put first
 * - Jackpot present & openInIframe: Next to last (above jackpot null)
 * - Jackpot null: Last
 * @private
 * @param {Array.<LotteryItem>} lotteryItems Array of lottery items
 * @returns {Array.<LotteryItem>} Returns sorted lottery items
 */

var sortLotteryItems = sortWith([descend(function (a) {
  return !prop('openInIframe', a) && prop('jackpot', a);
}), descend(function (a) {
  return prop('openInIframe', a) && prop('jackpot', a);
}), ascend(function (a) {
  return !prop('jackpot', a);
})]);
/**
 * Gets active draws (purchasable)
 * @private
 * @param {Array.<DrawItem>} products Array of product objects
 * @returns {Array.<DrawItem>} Returns array of active draws
 */

var getActiveDraws = filter(function (draw) {
  var isOpen = draw.state === 'open';
  var currentDate = new Date(Date.now());
  var closingDate = new Date(draw.closingDate);
  var notPassedClosingDate = currentDate.getTime() <= closingDate.getTime();
  return isOpen && notPassedClosingDate;
});
/**
 * Sort draws by drawing date
 * @private
 * @param {Array.<DrawItem>} drawItems Array of product objects
 * @returns {Array.<DrawItem>} Returns array of active draws
 */

var sortDrawsByDrawingDate = sort(comparator(function (a, b) {
  return new Date(a.drawingDate).getTime() < new Date(b.drawingDate).getTime();
}));
/**
 * Takes raw draws from Lottoland response and:
 * - Get's only active draws if it's not an instant game
 *  - All instant game draws always have the status "finished" even if they are open
 * - Only get this weeks draws:
 *  - Sorts according to drawing date
 *  - Filter draws by day
 * @private
 * @param {Array.<DrawItem>} rawDraws
 * @returns {Array.<DrawItem>} Returns max lines that's possible to purchase for the given lottery
 */

function getProcessedDraws(rawDraws, instant) {
  return pipe(function (draws) {
    return instant ? draws : getActiveDraws(draws);
  }, filterDrawsByDay, sortDrawsByDrawingDate)(rawDraws);
}
/**
 * Returns unique draws per day
 * @private
 * @param {Array.<DrawItem>} draws
 * @returns {Array.<DrawItem>} Returns unique draws per week day
 */

var filterDrawsByDay = uniqBy(function (draw) {
  return new Date(draw.drawingDate).getDay();
});
/**
 * Returns lottery item
 * @private
 * @param {string} productId Lottery productId (ex: 'polishLotto')
 * @param {Array.<DrawItem>} rawDraws
 * @param {Array.<PriceItem>} prices
 * @param {LotteryItemConfig} lotteryConfig
 * @returns {LotteryItem}
 */

function getLotteryItem(productId, rawDraws, prices, lotteryConfig) {
  var tags = propOr([], 'tags', lotteryConfig);
  var instant = contains('instant', tags);
  var draws = getProcessedDraws(rawDraws, instant);
  var nextDraw = head(draws);
  return {
    openInIframe: contains('iframe', tags),
    tags: tags,
    draws: draws,
    gameId: prop('id', lotteryConfig),
    imageUrl: prop('imageUrl', lotteryConfig),
    jackpot: prop('jackpotValue', lotteryConfig) || getJackpotCentsFromDraw(nextDraw),
    maxLines: prop('maxLinesCount', lotteryConfig),
    price: getPriceFromDraw(nextDraw, prices),
    productId: productId
  };
}
/**
 * Returns lottery items
 * @private
 * @param {Array.<DrawItem>} draws
 * @param {Array.<PriceItem>} prices
 * @param {Array.<LotteryItemConfig>} lotteryConfig
 * @returns {Array.<LotteryItem>}
 */

function getLotteriesWithDraws(draws, prices, lotteriesConfig) {
  return pipe(toPairs, map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        productId = _ref2[0],
        rawDraws = _ref2[1];

    return getLotteryItem(productId, rawDraws, prices, find(propEq('key', productId), lotteriesConfig) || {});
  }))(draws);
}
/**
 * Returns jackpot value
 * - baseJackpot & baseMarketingJackpot is jackpot in Euro,
 *   which is used to calculate draw price.
 * @private
 * @param {DrawItem} draw
 * @param {bool} base - Indicates if base jackpot should be returned (base jackpot is jackpot in Euro's)
 * @returns {number}
 */

function getJackpotCentsFromDraw(draw, base) {
  var drawJackpot = base ? 'baseJackpot' : 'jackpot';
  var drawMarketingJackpot = base ? 'baseMarketingJackpot' : 'marketingJackpot';
  return pipe(pathOr([], ['jackpots']), find(propEq('subgame', '')), function (jackpotObj) {
    return jackpotObj ? jackpotObj[drawJackpot] || jackpotObj[drawMarketingJackpot] : null;
  }, function (jackpot) {
    return jackpot > 0 ? jackpot : null;
  })(draw);
}
/**
 * Returns price with lowest possible jackpotUpperLimit when:
 * - Draw jackpot is 0: Returns price with lowest jackpotUpperLimit
 * - Draw jackpot is lower than a prices jackpotUpperLimit
 * @private
 * @param {DrawItem} draw
 * @param {Array.<PriceItem>} prices
 * @returns {number}
 */

function getPriceFromDraw(draw, prices) {
  var provider = prop('productId', draw);
  var priceOptions = getPriceOptionsByProductId(provider, prices, '');
  var jackpot = getJackpotCentsFromDraw(draw, true);
  return reduce(function (price, option) {
    return jackpot === 0 || option.jackpotUpperLimit > jackpot ? reduced(option.price) : option.price;
  }, null, priceOptions);
}
/**
 * Required sorting to make the price calculation work correctly
 * - Ascending by jackpotUpperLimit
 * - Null last
 * @private
 * @param {Array.<PriceItem>} prices
 * @returns {Array.<PriceItem>}
 */

var sortPricesByJackpotUpperLimit = sort(ascend(propOr(Infinity, 'jackpotUpperLimit')));
/**
 * Get price options by product id
 * - Ascending by jackpotUpperLimit
 * - Null last
 * @private
 * @param {string} productId Lottery productId (ex: 'polishLotto')
 * @param {Array.<PriceItem>} prices
 * @param {string} optionType Price option type (default: '')
 * @returns {Array.<PriceItem>}
 */

function getPriceOptionsByProductId(productId, prices, optionType) {
  return pipe(filter(whereEq({
    productId: productId || ''
  })), map(function (item) {
    return assoc('prices', map(function (price) {
      return assoc('jackpotUpperLimit', item.jackpotUpperLimit, price);
    }, item.prices), item);
  }), pluck('prices'), flatten, filter(propEq('option', optionType)), sortPricesByJackpotUpperLimit)(prices || []);
}

function startTrackingRequest(request) {
  return {
    type: START_TRACKING_REQUEST,
    payload: request
  };
}
function stopTrackingRequest(request) {
  return {
    type: STOP_TRACKING_REQUEST,
    payload: request
  };
}
function storeTickets(payload) {
  return {
    type: TICKETS_UPDATED,
    error: payload instanceof Error,
    payload: payload
  };
}
function storeBundles(payload) {
  return {
    type: BUNDLES_UPDATED,
    error: payload instanceof Error,
    payload: payload
  };
}
function clearQueryResults(payload) {
  return {
    type: QUERY_CLEARED,
    error: payload instanceof Error,
    payload: payload
  };
}
function replaceQueryResults(payload) {
  return {
    type: QUERY_UPDATED,
    error: payload instanceof Error,
    payload: payload
  };
}
function fetchResult(payload) {
  return {
    type: FETCH_RESULT,
    error: payload instanceof Error,
    payload: payload
  };
}
/**
 * Fetches lottery bundles
 * @private
 * @returns {Object} Redux action
 */

function fetchBundles() {
  return fetchLottoBundles({
    version: 1,
    success: function success(res) {
      return storeBundles(res.value.result);
    },
    failure: function failure() {
      return storeBundles(new Error('error.fetch.lotto.bundles'));
    }
  });
}
/**
 * Fetches lottery tickets & save to state
 * @private
 * @param {string} name Name of the query result (to store data in state)
 * @param {object} params Object to specify query
 * @param {array} params.tags Array of tags which narrows the query (ex: ['popular'])
 * @returns {Object} Redux action
 */

function fetchTickets(name, params) {
  return fetchProcessedLotteriesWithDraws({
    currencyId: params.currency,
    success: function success(productItems) {
      var indexByProductId = indexBy(prop('productId'));
      var queryResult = sortLotteryItems(params.tags ? getLotteryItemsByCategories(productItems, params.tags) : productItems);
      var queryResultIds = pluck('productId', queryResult);
      return [storeTickets(indexByProductId(productItems)), replaceQueryResults({
        name: name,
        ids: queryResultIds
      })];
    }
  });
}
/**
 * Fetches lottery tickets
 * @private
 * @returns {Object} Redux action
 */

function fetchLotteryTickets() {
  return getRequest("/draws", {
    success: function success(res) {
      return fetchResult(res);
    },
    failure: function failure() {
      return fetchResult(new Error('error.fetch.lotto.tickets'));
    }
  });
}
/**
 * Fetches lottery prices
 * @private
 * @returns {Object} Redux action
 */

function fetchLotteryPrices(currencyId) {
  return fetchLottoPrices(currencyId, {
    success: function success(res) {
      return fetchResult(res);
    },
    failure: function failure() {
      return fetchResult(new Error('error.fetch.lotto.ticket-prices'));
    },
    version: 1
  });
}
/**
 * Fetches lotteries
 * @private
 * @returns {Object} Redux action
 */

function fetchLotteriesConfig() {
  return searchGames({
    lotteries: {
      provider: 'Lottoland'
    }
  }, {
    success: function success(res) {
      return fetchResult(res);
    },
    failure: function failure() {
      return fetchResult(new Error('error.fetch.lotto.tickets-config'));
    },
    version: 2
  });
}
/**
 * Fetches lottery tickets with jackpot & prices
 * @private
 * @param {string} config.currencyId Currency id (ex: 'SEK')
 * @param {function} config.success
 * @returns {object} Returns EFFECT_COMPOSE action
 */

function fetchProcessedLotteriesWithDraws(config) {
  return bind([fetchLotteryTickets(), fetchLotteryPrices(config.currencyId), fetchLotteriesConfig()], function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        drawsFetchResult = _ref2[0],
        pricesFetchResult = _ref2[1],
        configFetchResult = _ref2[2];

    var prices = path(['payload', 'value', 'items'], pricesFetchResult);
    var draws = path(['payload', 'value', 'items'], drawsFetchResult);
    var lotteriesConfig = path(['payload', 'value', 'result', 'lotteries'], configFetchResult);

    if (prices && draws && lotteriesConfig) {
      return config.success(getLotteriesWithDraws(draws, prices, lotteriesConfig));
    }
  });
}

var initialState = {
  requests: []
};

function requestReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case START_TRACKING_REQUEST:
      {
        return assoc('requests', uniq(append(action.payload, state.requests)), state);
      }

    case STOP_TRACKING_REQUEST:
      {
        return assoc('requests', reject(equals(action.payload), state.requests), state);
      }

    default:
      return state;
  }
}

function ticketsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.error) {
    return state;
  }

  switch (action.type) {
    case TICKETS_UPDATED:
      {
        return action.payload;
      }

    default:
      return state;
  }
}

function bundlesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.error) {
    return state;
  }

  switch (action.type) {
    case BUNDLES_UPDATED:
      {
        return {
          entries: indexBy(prop('id'), action.payload),
          ids: pluck('id', action.payload)
        };
      }

    default:
      return state;
  }
}

function queryResultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.error) {
    return state;
  }

  switch (action.type) {
    case QUERY_UPDATED:
      {
        var _action$payload = action.payload,
            name = _action$payload.name,
            ids = _action$payload.ids;
        return assoc(name, ids, state);
      }

    case QUERY_CLEARED:
      {
        return dissoc(action.payload, state);
      }

    default:
      return state;
  }
}

var reducer = combineReducers({
  requests: requestReducer,
  tickets: ticketsReducer,
  queryResults: queryResultsReducer,
  bundles: bundlesReducer
});

/**
 * Gets tickets for a given query.
 * @param {Object} state
 * @param {Object} params
 * @param {string} params.queryName the name of the query
 * @returns {Array.<Object>} tickets for a given query
 * @example
 * getQueryResults(state, { queryName: 'myquery' })
 */

function getQueryResults(state, props) {
  return pathOr([], ['queryResults', prop('queryName', props)], state);
}
/**
 * Gets all tickets
 * @param {Object} state
 * @returns {Object} Tickets indexed by id
 * @example
 * getAllTickets(state)
 */

function getAllTickets(state) {
  return prop('tickets', state);
}
/**
 * Gets ticket with specified id.
 * @param {Object} state
 * @param {Object} params
 * @param {number} params.id the id of the ticket
 * @returns {Object} a ticket
 * @example
 * getTicket(state, { id: 'polishLotto' })
 */

function getTicket(state, props) {
  return prop(props.id, getAllTickets(state));
}
/**
 * Gets all lotto bundles
 * @param {Object} state
 * @returns {Object} Bundles indexed by id
 */

function getAllBundles(state) {
  return pathOr({}, ['bundles', 'entries'], state);
}
/**
 * Gets all lotto bundle id's (One bundle contain several tickets)
 * @param {Object} state
 * @returns {Array} Array of bundle id's
 */

function getBundleIds(state) {
  return pathOr([], ['bundles', 'ids'], state);
}
/**
 * Gets bundle by id
 * @param {Object} state
 * @returns {Object} Lotto bundle object
 * @example
 * getBundle(state.lottery, { id: '1' })
 */

function getBundle(state, props) {
  return prop(props.id, getAllBundles(state));
}
/**
 * Get all pending lotto requests
 * @param {Object} state
 * @returns {Array} Pending requests
 * @example
 * getPendingRequests(state.lottery)
 */

function getPendingRequests(state) {
  return prop('requests', state);
}

function getOption(options, optionName, state) {
  var option = path([optionName], options);

  if (typeof option === 'function') {
    return option(state);
  } else {
    return option;
  }
}
/**
 * Redux Effects middleware.
 * @param {object} options
 * @param {string|Function} options.operatorId
 *   Operator Id e.g. `hrg-bts` or (state) => getLottolandOperatorId(state.configuration)
 * @param {string|Function} options.host
 *   Host URL e.g. `https://test-hrg-bts.lttlapp.com` or (state) => getLottolandHost(state.configuration)
 * @param {Function} [options.tokenSelector]
 *   Function that gets Redux state and returns a session token
 */


function middleware(options) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === EFFECT_FETCH) {
          var state = store.getState();
          var operatorId = getOption(options, 'operatorId', state);
          var host = getOption(options, 'host', state);
          var params = {
            operatorId: operatorId,
            currencyId: options.currencyIdSelector && options.currencyIdSelector(state)
          };
          var url = "".concat(host, "/api/v1").concat(action.payload.url, "&").concat(querystring.encode(params));
          var nextAction = pipe(assoc('type', FETCH), assocPath(['payload', 'url'], url))(action);
          var uuid = path(['meta', 'uuid'], nextAction);

          if (uuid) {
            store.dispatch(startTrackingRequest(uuid));
          }

          return next(nextAction).then(function (result) {
            if (uuid) {
              store.dispatch(stopTrackingRequest(uuid));
            }

            return result;
          });
        }

        return next(action);
      };
    };
  };
}

var LottoTicketQuery =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LottoTicketQuery, _React$Component);

  function LottoTicketQuery() {
    _classCallCheck(this, LottoTicketQuery);

    return _possibleConstructorReturn(this, _getPrototypeOf(LottoTicketQuery).apply(this, arguments));
  }

  _createClass(LottoTicketQuery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onFetch();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onClear();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (not(equals(prevProps.params, this.props.params))) {
        this.props.onFetch();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        ids: this.props.ids
      });
    }
  }]);

  return LottoTicketQuery;
}(React.Component);
LottoTicketQuery.propTypes = {
  children: PropTypes.func,
  name: PropTypes.string.isRequired,
  ids: PropTypes.array.isRequired,
  params: PropTypes.object.isRequired,
  onClear: PropTypes.func.isRequired,
  onFetch: PropTypes.func.isRequired
};

function mapStateToProps(state, props) {
  var localState = prop(props.mountPoint, state);
  return {
    ids: getQueryResults(localState, {
      queryName: props.name
    })
  };
}

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators({
    onClear: function onClear() {
      return clearQueryResults(props.name);
    },
    onFetch: function onFetch() {
      return fetchTickets(props.name, props.params);
    }
  }, dispatch);
}

var LottoTicketQuery$1 = compose(setPropTypes({
  name: PropTypes$1.string.isRequired,
  mountPoint: PropTypes$1.string.isRequired
}), connect(mapStateToProps, mapDispatchToProps))(LottoTicketQuery);

var LottoBundles =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LottoBundles, _React$Component);

  function LottoBundles() {
    _classCallCheck(this, LottoBundles);

    return _possibleConstructorReturn(this, _getPrototypeOf(LottoBundles).apply(this, arguments));
  }

  _createClass(LottoBundles, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onFetch();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        ids: this.props.ids
      });
    }
  }]);

  return LottoBundles;
}(React.Component);
LottoBundles.propTypes = {
  children: PropTypes.func,
  ids: PropTypes.array.isRequired,
  onFetch: PropTypes.func.isRequired
};

function mapStateToProps$1(state, props) {
  var localState = prop(props.mountPoint, state);
  return {
    ids: getBundleIds(localState)
  };
}

function mapDispatchToProps$1(dispatch) {
  return bindActionCreators({
    onFetch: fetchBundles
  }, dispatch);
}

var LottoBundles$1 = compose(setPropTypes({
  mountPoint: PropTypes$1.string.isRequired
}), connect(mapStateToProps$1, mapDispatchToProps$1))(LottoBundles);

export { startTrackingRequest, stopTrackingRequest, storeTickets, storeBundles, clearQueryResults, replaceQueryResults, fetchResult, fetchBundles, fetchTickets, fetchLotteryTickets, fetchLotteryPrices, fetchLotteriesConfig, fetchProcessedLotteriesWithDraws, reducer, getQueryResults, getAllTickets, getTicket, getAllBundles, getBundleIds, getBundle, getPendingRequests, middleware, LottoTicketQuery$1 as LottoTicketQuery, LottoBundles$1 as LottoBundles };
//# sourceMappingURL=index.es.js.map
